import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: '10px 32px 32px 32px',
    background: theme.colorPalette.white_30
  },
  section: {
    paddingBottom: 32
  },
  column: {
    width: '50%'
  },
  carDetails: {
    paddingBottom: 32,
    '&:last-child': {
      paddingBottom: 0
    }
  },
  notification: {
    display: 'flex',
    boxShadow: 'none'
  }
}));

export default useStyles;
